import { Link, useLocation } from "react-router-dom";
import { BookMarked, Network } from "lucide-react";

export default function AppNav() {
  const { pathname } = useLocation();
  const items = [
    { to: "/", label: "Library", icon: BookMarked, testId: "nav-library" },
    { to: "/map", label: "Map", icon: Network, testId: "nav-map" },
  ];
  return (
    <nav className="flex items-center gap-1 bg-[#FCE7F3] dark:bg-[#2E2140] rounded-lg p-1">
      {items.map((it) => {
        const active = pathname === it.to;
        const Icon = it.icon;
        return (
          <Link
            key={it.to}
            to={it.to}
            data-testid={it.testId}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              active
                ? "bg-white dark:bg-[#3B2350] text-[#C9286F] dark:text-[#C4A1FF] shadow-sm"
                : "text-[#5E4B70] dark:text-[#BBA9CF] hover:text-[#3B2350] dark:hover:text-[#FBEFF6]"
            }`}
          >
            <Icon className="w-4 h-4" />
            {it.label}
          </Link>
        );
      })}
    </nav>
  );
}
